import {Bar} from 'vue-chartjs'

export default {
    name: 'component__bar-chart-fff',
    extends: Bar,
    props: {
        chartData: {
            type: Object,
            default: {}
        },

    },
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true,
                    mode: 'label',
                    intersect: false
                },
                legend: {
                    display: false,
                    labels: {
                        fontColor: 'rgb(255, 99, 132)'
                    }
                },
                scales: {
                    xAxes: [
                        {
                            display: false,
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            display: false
                        }
                    ]
                },
                hover: {
                    mode: 'nearest',
                    intersect: false,
                    axis: 'xy'
                }

            }
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    },
    methods: {
        repaint(chartData) {
            // console.log(this.options);
            this.renderChart(chartData, this.options)
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/keyword/component__bar_chartjs.js